import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import BrandLogo from "@/components/BrandLogo";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export default function ResetPassword() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const token = new URLSearchParams(window.location.search).get("token");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      const res = await api.post("/auth/password/reset", { token, new_password: pw });
      setUser(res.data.user);
      navigate("/dashboard");
    } catch (err) {
      setError(err.response?.data?.detail || "This reset link is invalid or has expired.");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#000000] text-white px-6">
      <div className="w-full max-w-sm" data-testid="reset-password-page">
        <BrandLogo variant="light" size={30} className="mb-10" />
        <h1 className="font-display text-3xl font-extrabold tracking-tight">Set a new password</h1>
        <p className="mt-2 text-sm text-slate-400">Choose a new password to finish resetting your account.</p>
        {!token ? (
          <div className="mt-8 text-sm text-rose-400">This reset link is missing its token.</div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-3">
            <div>
              <Label className="text-xs text-slate-400">New password</Label>
              <Input data-testid="reset-password-input" type="password" required value={pw}
                onChange={(e) => setPw(e.target.value)} className="mt-1 bg-[#111111] border-slate-800 text-white h-11"
                placeholder="At least 8 characters" />
            </div>
            {error && <div data-testid="reset-error" className="text-xs text-rose-400 bg-rose-500/10 rounded px-3 py-2">{error}</div>}
            <Button data-testid="reset-submit-button" type="submit" disabled={busy}
              className="h-11 w-full bg-[#F4C400] hover:bg-[#D9AE00] text-[#000000] rounded-lg text-sm font-bold">
              {busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Reset password &amp; sign in
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
